export var ContactSortTypes;
(function (ContactSortTypes) {
    ContactSortTypes["ALPHABETICAL_ASC"] = "ALPHABETICAL_ASC";
    ContactSortTypes["ALPHABETICAL_DESC"] = "ALPHABETICAL_DESC";
    ContactSortTypes["NUMBER_UNPAID_INVOICES_ASC"] = "NUMBER_UNPAID_INVOICES_ASC";
    ContactSortTypes["NUMBER_UNPAID_INVOICES_DESC"] = "NUMBER_UNPAID_INVOICES_DESC";
})(ContactSortTypes || (ContactSortTypes = {}));
//# sourceMappingURL=contact.js.map